{
  "name": "merlin",
  "version": "4.8.0-beta-0014",
  "type": "module",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start-local": "ng serve --configuration local",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "unit": "ng test unit --watch=false --browsers=ChromeHeadless",
    "e2e": "playwright test",
    "e2e:ui": "playwright test --ui",
    "e2e:headed": "playwright test --headed",
    "e2e:report": "playwright show-report",
    "lint": "ng lint",
    "prettier": "npx prettier --write .",
    "clean": "rm -rf **/*/dist **/*/node_modules node_modules"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.1.0",
    "@angular/cdk": "^22.1.1",
    "@angular/common": "^22.1.0",
    "@angular/compiler": "^22.1.0",
    "@angular/core": "^22.1.0",
    "@angular/forms": "^22.1.0",
    "@angular/material": "^22.1.1",
    "@angular/platform-browser": "^22.1.0",
    "@angular/platform-browser-dynamic": "^22.1.0",
    "@angular/router": "^22.1.0",
    "@angular/service-worker": "^22.1.0",
    "@camelot/calendar": "^4.0.12-beta.15",
    "@camelot/capacitor": "^4.0.12-beta.15",
    "@camelot/charts": "^4.0.12-beta.15",
    "@camelot/cms": "^4.0.12-beta.15",
    "@camelot/core": "^4.0.12-beta.15",
    "@camelot/eslint-config": "^4.0.12-beta.15",
    "@camelot/files-basic": "^4.0.12-beta.15",
    "@camelot/form-basic": "^4.0.12-beta.15",
    "@camelot/form-input": "^4.0.12-beta.15",
    "@camelot/form-model": "^4.0.12-beta.15",
    "@camelot/icons": "^4.0.12-beta.15",
    "@camelot/menu": "^4.0.12-beta.15",
    "@camelot/notification": "^4.0.12-beta.15",
    "@camelot/planning": "^4.0.12-beta.15",
    "@camelot/prettier-config": "^4.0.12-beta.15",
    "@camelot/project": "^4.0.12-beta.15",
    "@camelot/server": "^4.0.12-beta.15",
    "@camelot/services": "^4.0.12-beta.15",
    "@camelot/styles": "^4.0.12-beta.15",
    "@camelot/translation": "^4.0.12-beta.15",
    "@camelot/ui": "^4.0.12-beta.15",
    "@camelot/user": "^4.0.12-beta.15",
    "@camelot/utils": "^4.0.12-beta.15",
    "@camelot/wysiswyg": "^4.0.12-beta.15",
    "@capacitor/camera": "^5.0.4",
    "@danielmoncada/angular-datetime-picker": "^21.0.0",
    "angular-google-tag-manager": "^1.7.0",
    "bootstrap": "5.2.3",
    "dompurify": "^3.4.16",
    "inquirer": "^12.2.0",
    "luxon": "^3.6.1",
    "postal-mime": "^3.0.1",
    "rxjs": "~7.8.0",
    "simple-git": "^3.27.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^22.1.3",
    "@angular-eslint/builder": "22.1.0",
    "@angular-eslint/eslint-plugin": "22.1.0",
    "@angular-eslint/eslint-plugin-template": "22.1.0",
    "@angular-eslint/schematics": "22.1.0",
    "@angular-eslint/template-parser": "22.1.0",
    "@angular/cli": "^22.1.3",
    "@angular/compiler-cli": "^22.1.0",
    "@playwright/test": "^1.62.1",
    "@types/jasmine": "~5.1.0",
    "@types/node": "^20.14.5",
    "@typescript-eslint/eslint-plugin": "^8.66.0",
    "@typescript-eslint/parser": "^8.66.0",
    "eslint": "^9.39.5",
    "istanbul-lib-instrument": "^6.0.3",
    "jasmine-core": "~5.1.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "ng-packagr": "^22.1.1",
    "typescript": "~6.0.3"
  }
}
